export default __webpack_public_path__ + "img/pin_icons/electrical_motor_w.png";